import $store, { externalFontFaceDeclarationsSelector } from "../../../../../store";

import { MarkerPart } from "../shared";

import "./DecorationFont.scss";

export class DecorationFont extends MarkerPart {
  get defaultReactiveState() {
    return {
      fontFamily: 'unset',
      registeredFontFaces: {} as Record<string, string>,
    };
  }

  get reactiveStateStoreHandler() {
    return {
      get registeredFontFaces() {
        return externalFontFaceDeclarationsSelector($store.getState());
      },
    };
  }

  Content({ id, extraProps }: { id: string, extraProps: Record<string, string> }) {
    const fontProperties = `font-family: ${this.reactiveState.fontFamily};`;
    return (
      <style {...extraProps} id={`marker-${id}-decoration-font`}>
        {`#marker-${id} .marker-decoration {\n  ${fontProperties}\n}`}
      </style>
    );
  }

  Thumbnail() {
    return null;
  }

  Configuration() {
    return (
      <div className="font-settings">
        <select
          className=""
          value={this.reactiveState.fontFamily}
          onChange={(e) => {
            const family = e.currentTarget.value;
            this.reactiveState.fontFamily = family;
          }}
        >
          <option value="unset">Use map default</option>
          <option value="Poppins">Poppins</option>
          {Object.values(this.reactiveState.registeredFontFaces).map((rule) => {
            const fontFace = rule.match(/@font-face\s*{([^}]*)}/)?.[1];
            const descriptor = fontFace ? Object.fromEntries(
              fontFace.split(';').map((part) => part.trim().split(':').map((s) => s.trim()) as [string, string])
            ) : null;

            if (!descriptor || !descriptor['font-family']) return null;

            const family = descriptor['font-family'].replace(/['"]/g, '');
            return (
              <option key={family} value={family}>{family}</option>
            );
          })}
        </select>
        <span className="info">* Add more fonts on Map Settings</span>
      </div>
    );
  }

  title = 'Font';
}
